import { createContext } from "react";

const TopBarContext = createContext();
export default TopBarContext;
